import {Component, OnInit, ViewChild} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';
import {Categoria} from '../models/categoria'
import {MatSnackBar} from '@angular/material';;
import {Macchina} from '../models/macchina';
import {TwsCategoriaComponent} from '../tws-categoria/tws-categoria.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import * as FileSaver from "file-saver";
import 'rxjs/add/operator/switchMap';

@Component({
    selector: 'app-tws-documentazione',
    templateUrl: './tws-documentazione.component.html',
    styleUrls: ['./tws-documentazione.component.css']
})
export class TwsDocumentazioneComponent implements OnInit {
    @ViewChild(TwsCategoriaComponent) private categorieComponent: TwsCategoriaComponent;
    tutteCategorie: Array<Categoria>;
    categoriaCorrente: Categoria = new Categoria(0, "", "", 0);
    macchinaSelezionata: Macchina;
    mostraRisultati: boolean = false;
    tipoSelezionato: any;
    tipiDocumentazione: Array<any>;//da ricerca
    codice: string;
    ricerca: boolean = false;
    risultatiDocumenti: any;
    lastCategoria: any;
    nomeListaArea: string = "";
    lastMacchina: any;
    caricamento: boolean = false;
    totale: number = 0;
    erroreRicerca: boolean = false;
    //massimo: number = 100 * 1024 * 1024;//100MB
    massimo: number = 1024 * 1024 * 250;//1000MB
    nonCatalogo = 1000;
    urlDownload = "";
    lastSearch: string = "";
    bloccoOver: any;
    constructor(public snackBar: MatSnackBar, private ricambiService: RicambiService, private route: ActivatedRoute, private location: Location, private router: Router) {}

    ngDoCheck() {
        let idCategoria = +this.route.snapshot.params['id'];
        let search: string = this.route.snapshot.params['search'];

        if (idCategoria || search) {
            if (search != this.lastSearch || idCategoria != this.lastCategoria) {
                this.lastCategoria = idCategoria;
                this.lastSearch = search;
                this.ngOnInit();
            }
        } else {
            this.lastCategoria = idCategoria;
            this.lastSearch = search;
        }


    }


    ngOnInit() {
        console.log("INI");
        this.reset();
        this.ricambiService.getCategorie().then(heroes => {this.tutteCategorie = heroes;});
        let idCategoria = +this.route.snapshot.params['id'];
        let search: string = this.route.snapshot.params['search'];
        //let idMacchina = +this.route.snapshot.params['mac'];
        if (idCategoria) {
            this.lastCategoria = idCategoria;
            this.ricambiService.getAreaDocumentazione().then(heroes => {
                this.tipiDocumentazione = heroes;
                let categoria: Categoria[] = heroes.filter(categoria => categoria.id == idCategoria);
                this.categoriaCorrente = categoria[0];
                this.onRouteCategoria(this.categoriaCorrente);
            });
        } else {//parto da 0
            this.ricambiService.getAreaDocumentazione().then(mac => this.tipiDocumentazione = mac);
            if (search) {
                this.codice = search;
                this.onCercaDocumentazione();
            } else {
                this.caricamento = false;
                this.caricataCategoria(this.categoriaCorrente);
            }
        }


    }

    caricataCategoria(hero: Categoria): void {
        this.categoriaCorrente = hero;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
    }

    onRouteCategoria(hero: Categoria): void {
        this.caricamento = false;
        this.caricataCategoria(hero);
        this.docCategoria(this.categoriaCorrente);
    }

    reset(): void {
        this.caricamento = true;
        this.erroreRicerca = false;
        this.nomeListaArea = RicambiService.traduci("Area documenti");
        this.ricerca = false;
        this.codice = "";
        this.categoriaCorrente = new Categoria(0, "", "", 0);
        this.macchinaSelezionata = undefined;
        this.risultatiDocumenti = undefined;
        this.macchinaSelezionata = undefined;
        this.risultatiDocumenti = undefined;
        this.mostraRisultati = false;
        this.toggle = false;

    }

    onSelectCategoria(hero: Categoria): void {
        this.codice = "";
        this.router.navigate(['/documentazione', hero.id]);
    }

    get navigazione(): Array<Categoria> {
        if (this.categorieComponent) {
            return this.categorieComponent.navigazione;
        } else {
            return new Array<Categoria>();
        }
    }

    docCategoria(categoria: Categoria): void {
        this.risultatiDocumenti = undefined;
        this.mostraRisultati = false;
        this.erroreRicerca = false;
        this.caricamento = true;
        this.ricambiService.cercaDocumentazione(this.categoriaCorrente.id, "").then(mac => this.risultatiDocumentazione(mac));
    }

    onCercaDocumentazione(): void {
        this.ricerca = true;
        this.caricamento = true;
        this.erroreRicerca = false;
        this.risultatiDocumenti = undefined;
        this.mostraRisultati = false;
        this.ricambiService.cercaDocumentazione(0, this.codice).then(mac => this.risultatiRicerca(mac));
    }

    cercaDocumentazione(): boolean {
        if (!this.codice || this.codice.length < 3) {
            this.erroreRicerca = true;
            return;
        }
        this.router.navigate(['/documentazione', 0, this.codice]);
        return false;
        /*
        this.erroreRicerca=false;
        this.risultatiDocumenti = undefined;
        this.ricambiService.cercaDocumentazione(0, this.codice).then(mac => this.risultatiRicerca(mac));*/
    }

    risultatiDocumentazione(risultati: any): void {
        this.risultatiDocumenti = risultati;
        this.mostraRisultati = !(Object.keys(risultati).length === 0);
        this.ricerca = false;
        this.toggle = false;
        this.totale = 0;
        this.erroreRicerca = false;
        this.caricamento = false;
    }
    risultatiRicerca(risultati: any): void {
        this.ricerca = true;
        this.risultatiDocumenti = risultati;
        this.mostraRisultati = !(Object.keys(risultati).length === 0);
        this.toggle = false;
        this.totale = 0;
        this.erroreRicerca = false;
        this.caricamento = false;
    }



    get rootCategoria(): Array<Categoria> {
        let l = this.categorieFigli(0);

        return l;
    }

    categorieFigli(idCategoria: number): Array<Categoria> {
        let l = new Array<Categoria>();
        if (this.tutteCategorie) {
            l = this.tutteCategorie.filter(categoria => categoria.padre == idCategoria);
        }
        return l;
    }

    calcolaFile(idCategoria: number): Array<any> {
        if (this.risultatiDocumenti) {
            return this.risultatiDocumenti[idCategoria];
        }
        return null;
    }
    calcolaFileMacchina(idCategoria: number, idMacchina: number): Array<any> {
        if (this.risultatiDocumenti) {
            return this.risultatiDocumenti[idCategoria]["macchine"][idMacchina];
        }
        return null;
    }

    calcolaMacchine(idCategoria: number): Array<any> {
        let files: Array<any> = new Array<any>();
        if (this.risultatiDocumenti && this.risultatiDocumenti[idCategoria]["macchine"]) {
            for (var m in this.risultatiDocumenti[idCategoria].macchine) {
                files.push(this.risultatiDocumenti[idCategoria].macchine[m]);
            }
        }
        return files;
    }

    calcolaUrlDownload(): void {
        let files: Array<number> = this.getSelezionati();

        this.urlDownload = this.ricambiService.urlDownloadDocumentazione(files);
    }
    selezionaMacchina(idCategoria: number, idMacchina: number) {
        if (this.risultatiDocumenti) {
            if (this.risultatiDocumenti[idCategoria] && this.risultatiDocumenti[idCategoria]["macchine"]) {
                let sel = this.risultatiDocumenti[idCategoria]["macchine"][idMacchina].selezionato;
                sel = !sel;
                this.risultatiDocumenti[idCategoria]["macchine"][idMacchina].selezionato = sel;
                for (var i = 0; i < this.risultatiDocumenti[idCategoria]["macchine"][idMacchina].files.length; i++) {
                    let x: any = this.risultatiDocumenti[idCategoria]["macchine"][idMacchina].files[i];

                    x.selezionato = sel;
                }
                this.calcolaUrlDownload();
            }
        }
    }

    selezionaCategoria(idCategoria: number) {
        if (this.risultatiDocumenti) {
            let sel = this.risultatiDocumenti[idCategoria].selezionato;
            sel = !sel;
            this.risultatiDocumenti[idCategoria].selezionato = sel;
            for (var i = 0; i < this.risultatiDocumenti[idCategoria].files.length; i++) {
                let x: any = this.risultatiDocumenti[idCategoria].files[i];

                x.selezionato = sel;
            }
            this.calcolaUrlDownload();
        }
    }

    selezionato(file) {
        file.selezionato = !file.selezionato;

        this.calcolaUrlDownload();
        return false;
    }
    getSelezionati(): Array<number> {
        let files: Array<number> = new Array<number>();
        this.totale = 0;
        for (var x in this.risultatiDocumenti) {
            if (this.risultatiDocumenti[x].files) {
                for (var i = 0; i < this.risultatiDocumenti[x].files.length; i++) {
                    let y: any = this.risultatiDocumenti[x].files[i];
                    if (y.selezionato) {
                        this.totale += y.dimensioni;
                        files.push(y.id);
                    }
                }
            }
            if (this.risultatiDocumenti[x].macchine) {
                for (var m in this.risultatiDocumenti[x].macchine) {
                    for (var i = 0; i < this.risultatiDocumenti[x].macchine[m].files.length; i++) {
                        let y: any = this.risultatiDocumenti[x].macchine[m].files[i];
                        if (y.selezionato) {
                            this.totale += y.dimensioni;
                            files.push(y.id);
                        }
                    }
                }
            }
        }
        return files;
    }

    toggle: boolean = false;
    clickToggle(): void {
        this.toggle = !this.toggle;
    }

    out(event: any, file: any): void {
         console.log("PUT "+file.path);
        this.bloccoOver = {};
        this.bloccoOver["display"] = "none";
    }
    over(event: any, file: any): void {
        console.log("img "+file.path);
        if (file.isImage) {
            this.bloccoOver = {};
            this.bloccoOver["display"] = "block";
            this.bloccoOver["left"] = event.pageX + "px";
            this.bloccoOver["top"] = event.pageY + 20 + "px";
            this.bloccoOver["background-image"] = "url('" + file.url + "')";
        } else {
            this.bloccoOver = {};
            this.bloccoOver["display"] = "none";
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/tws-documentazione/tws-documentazione.component.ts